import React from "react"

import ListWidgetHeader from "../../common/ListWidgetHeader"
import SourceListContainer from "./SourceListContainer"
import SearchBar from "../../common/SearchBar"

const SourceListWidget = ({
    onFilterSelect,
    isFetching,
    invalidate,
    pagingRequest,
    nameSearchTerm,
    isAddingEnabled,
    onSearch,
    onAdd
}) => (
    <div className="widget">
        <ListWidgetHeader
            isFetching={isFetching}
            canAdd={isAddingEnabled}
            iconComponent={<span className="icon icon-source" />}
            listTitle="Sources"
            invalidate={invalidate(pagingRequest)}
            onAdd={onAdd}
            onFilterSelect={onFilterSelect(pagingRequest)}
        />
        <div className="quick-filters">
            <SearchBar searchTerm={nameSearchTerm} onSearch={onSearch} />
        </div>
        <SourceListContainer />
    </div>
)

export default SourceListWidget
